<template>
  <div id="home">
    <left-sidebar />

    <network-map @loading="pageIsLoading = $event"/>

    <right-sidebar-close />
    <right-sidebar-open v-show="sidebarIsOpen" />

    <loading-spinner
      :active.sync="pageIsLoading"
      :is-full-page="true"
      color="#4fa2b7"
      :height="200"
      :width="200"
    />

    <select-workspace-dialog-box
      v-if="isDialogOpen"
      :workspace-options="workspacesContainObject"
      :workspaces="workspaces"
      :object-coordinate="objectCoordinate"
      style="z-index: 10"
      @close="closeSelectWorkspaceDialogBox"
      @confirm="openOnWorkspace"
    />

    <workspaces-not-found-dialog-box
      v-if="workspacesContainObject && workspacesContainObject.length === 0"
      style="z-index: 10"
      @close="closeSelectWorkspaceDialogBox"
    />


  </div>
</template>

<script>
import LeftSidebar from "@/components/Network/LeftSidebar/LeftSidebar";
import NetworkMap from "@/components/Network/Map/NetworkMap";
import RightSidebarOpen from "@/components/Network/RightSidebar/RightSidebarOpen";
import RightSidebarClose from "@/components/Network/RightSidebar/RightSidebarClose";
import { mapActions } from "vuex";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import SelectWorkspaceDialogBox from "@/components/Network/Content/SelectWorkspaceDialogBox";
import WorkspacesNotFoundDialogBox from "@/components/Network/Content/WorkspacesNotFoundDialogBox";
import LoadingSpinner from "vue-loading-overlay";
import { bus } from "@/main";
import { getArea, getLength } from "ol/sphere";
import RightSidebarTools from "./RightSidebar/RightSidebarTools.vue";
import {Vector as VectorSource,}from "ol/source.js";;
export default {
  name: "Network",

  components: {
    LoadingSpinner,
    WorkspacesNotFoundDialogBox,
    SelectWorkspaceDialogBox,
    RightSidebarClose,
    RightSidebarOpen,
    NetworkMap,
    LeftSidebar,
    RightSidebarTools,

  },

  mixins: [managementDatatableMixin],

  data() {
    return {
      /**
       * Defines if the page is loading
       */
      pageIsLoading: false,

      /**
       * List of workspaces that contain the selected object
       */
      workspacesContainObject: null,

      /**
       * Coordinate of selected object
       */
      objectCoordinate: null,
      workspaces: null,
      isDialogOpen: false,
    };
  },

  computed: {
    /**
     * Determines whether the right sidebar is open or closed.
     * @returns {boolean}
     */
    sidebarIsOpen() {
      return !!this.$store.getters.getCurrentlyOpenTabSidebar;
    },
     currentActionType() {
      return this.$store.getters.tools_selectedAction;
    },
  },

  mounted() {
    bus.$on("open-on-workspace", object => {
      this.getWorkspacesContainsObject(
        object.layer,
        object.uuid,
        object.coordinates
      );
    });
  },

  created() {
    if (this.userHasFibercloudPermission("list_list")) {
      this.GET_ALL_LISTS();
    }
    if (this.$store.getters.getAllObjectTypesProperties.length === 0) {
      this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS();
    }
  },

  destroyed() {
    bus.$off("open-on-workspace");
  },

  methods: {
    ...mapActions([
      "fetchWorkspacesContainsObject",
      "GET_ALL_LISTS",
      "FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS",
      "centerObjectNetworkOnWorkspace",
      "setCurrentWorkspace",
      "RESET_NETWORK_DIAGRAM_STATE",
    ]),

    /**
     * Search for possible workspaces that contain the object
     * @param layer - Selected object layer
     * @param objectUuid - Selected object uuid
     * @param objectCoordinate - Selected object coordinates
     * @returns {Promise<void>}
     */
    async getWorkspacesContainsObject(layer, objectUuid, objectCoordinate) {
      this.pageIsLoading = true;
      try {
        const workspacesOptions = [];
        this.workspaces = await this.fetchWorkspacesContainsObject(
          {
            objectType: layer,
            objectUuid: objectUuid
          }
        );
        this.pageIsLoading = false;
        this.workspaces.forEach(workspace =>{
          workspacesOptions.push({
            id: workspace.wp_id,
            label: workspace.wp_label
          })
        });
        this.objectCoordinate = objectCoordinate;
        this.workspacesContainObject = workspacesOptions;
        this.isDialogOpen = true;
      } catch (e) {
        console.error(e);
        this.pageIsLoading = false;
      }
    },

    /**
     * Show objects in selected workspace
     * @param workspaceSelected
     * @returns {Promise<void>}
     */
    async openOnWorkspace(workspaceSelected, newTab) {
      try {
        this.centerObjectNetworkOnWorkspace(this.objectCoordinate);
        await this.setCurrentWorkspace(workspaceSelected);
        await this.RESET_NETWORK_DIAGRAM_STATE();
        if (this.$route.path !== "/home") {
          if (newTab) {
            let routeData = this.$router.resolve({
              name: "home",
              params: { workspace_uuid: workspaceSelected.wp_uuid }
            });
            //convert json to object
            const objectCoordinates = this.objectCoordinate.coordinates;
            window.open(routeData.href + "workspaces/" + routeData.location.params.workspace_uuid + `/@${objectCoordinates[1]},${objectCoordinates[0]},23z`, '_blank');
          } else {
            this.$router.push({
              name: "home",
              params: { workspace_uuid: workspaceSelected.wp_uuid }
            });
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isDialogOpen = false;
      }
    },

     /**
     * Close the dialog box that is open
     */
    closeSelectWorkspaceDialogBox() {
      this.isDialogOpen = false;
      this.workspacesContainObject = null;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Network/Network.vue